import { getExperiment } from '@eventbrite/statsig';
import { css } from 'emotion';
import React, { useEffect } from 'react';
import { UrgencyHighlights, UrgencyMessages } from '../UrgencySignals';
import type { MusicProps } from './EventHero';
import { MusicEventBlock } from './MusicEventBlock';
import { OrganizerInfo, Props as OrganizerInfoProps } from './OrganizerInfo';

type Props = {
    hasCroppedLogo: boolean;
    isSeriesParent: boolean;
    startDateTime: string;
    startMonthAbbr: string;
    hasArtistPresentedByModule: boolean;
    hasPresenterOrAgeRestriction: boolean;
    eventNameTruncated: string;
    eventName: string;
    displayOrganizationName: string;
} & MusicProps &
    OrganizerInfoProps;

export const Body = ({
    hasCroppedLogo,
    isSeriesParent,
    startDateTime,
    startMonthAbbr,
    hasArtistPresentedByModule,
    hasPresenterOrAgeRestriction,
    eventName,
    eventNameTruncated,
    displayOrganizationName,
    orgProfileLink,
    organizationNameTruncated,
    hasPresenter,
    presenter,
    hasAgeRestriction,
    ageRestriction,
}: Props) => {
    const [isExperimentEnabled, setIsExperimentEnabled] = React.useState(false);

    useEffect(() => {
        const value = getExperiment(
            'urgency_signals_in_listing_page',
            'is_experiment_enabled',
            false,
        );

        setIsExperimentEnabled(value);
    }, []);

    return (
        <div
            className={`listing-hero-body ${
                isSeriesParent ? 'listing-hero-body--parent' : ''
            }`}
        >
            {isSeriesParent && (
                <time
                    data-testid="listing-hero-date-mobile"
                    dateTime={startDateTime}
                >
                    <p className="listing-hero-image--month show-medium l-pad-bot-2">
                        {startMonthAbbr}
                    </p>
                </time>
            )}

            {isExperimentEnabled && (
                <div>
                    <div className={style.urgencySignals}>
                        <div className="hide-large">
                            <UrgencyMessages />
                        </div>
                        <UrgencyHighlights />
                    </div>
                </div>
            )}

            {!hasArtistPresentedByModule && !hasPresenterOrAgeRestriction && (
                <>
                    <h1
                        className="listing-hero-title"
                        data-testid="event-name-non-music"
                    >
                        {eventNameTruncated}
                    </h1>
                    <div id="listings-root__link-to-creator-collections"></div>
                    <meta content={eventName} />
                    {displayOrganizationName && (
                        <OrganizerInfo
                            orgProfileLink={orgProfileLink}
                            organizationNameTruncated={
                                organizationNameTruncated
                            }
                        />
                    )}
                </>
            )}

            {hasPresenterOrAgeRestriction && !hasCroppedLogo && (
                <>
                    <div className="has-user-generated-content listing-hero--no-image__justify-content hide-large hide-medium">
                        <div className="l-pad-left-4 structured-content__module">
                            <MusicEventBlock
                                isCreatorCollectionsLinkMobile={true}
                                eventNameTruncated={eventNameTruncated}
                                hasPresenter={hasPresenter}
                                presenter={presenter}
                                hasAgeRestriction={hasAgeRestriction}
                                ageRestriction={ageRestriction}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

const style = {
    urgencySignals: css`
        margin-left: -4px;
        margin-right: -4px;
        margin-bottom: 20px;
    `,
};
